import Container from "../components/element/container";
import { toast } from "react-toastify";
import Icon from "../components/element/icon";
import i18n from "../i18n/i18n";

// Toasts are raised from plain functions, outside any component, so the copy
// is translated here. Text with no entry (a name, an API message) is shown as is.
const translate = (text) => (typeof text === "string" ? i18n.t(text) : text);

let isToastActive = false; // Global flag to track active toast

export const showToast = (
  title,
  description,
  type = "success",
  options = {},
) => {
  if (isToastActive) return; // Prevent spam if a toast is already active

  isToastActive = true; // Lock to prevent multiple toasts

  const content = (
    <Container tag="div" className="ms-2">
      <h6>{translate(title)}</h6>
      <p>{translate(description)}</p>
    </Container>
  );

  const toastOptions = {
    autoClose: 2000,
    onClose: () => {
      isToastActive = false; // Unlock when toast closes
    },
    ...options,
  };

  switch (type) {
    case "success":
      toast.success(content, {
        icon: (
          <Icon
            icon="fluent-mdl2:completed-solid"
            className="toast-icon --success"
          />
        ),
        ...toastOptions,
      });
      break;
    case "warning":
      toast.warning(content, {
        icon: (
          <Icon icon="ix:warning-filled" className="toast-icon --warning" />
        ),
        ...toastOptions,
      });
      break;
    case "error":
      toast.error(content, {
        icon: (
          <Icon icon="gridicons:cross-circle" className="toast-icon --error" />
        ),
        ...toastOptions,
      });
      break;
    default:
      toast.info(content, toastOptions);
      break;
  }
};
